import { SendPushNotificationWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('SendPushNotification')
export class SendPushNotificationNodeSchemaProvider extends SchemaProvider<SendPushNotificationWorkflowNode> {}
